import {Button, Container, Description, Form, Highlight} from "../SharedStyles";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";


const LoginRequested = () => {
  const navigate = useNavigate();
  const email = useSelector((state) => state.user.email);

  const handleRequest = (e) => {
    e.preventDefault();
    navigate('/')
  };

  return (
    <Container>
      <Form onSubmit={handleRequest}>
        <Description>Password reset request for <Highlight>{email}</Highlight> has been sent.</Description>
        <Description>Please check your email for password reset instructions.</Description>
        <Button type="submit">Back to homepage</Button>
      </Form>
    </Container>
  );
};

export default LoginRequested;